<script setup lang="ts">
const store = useSongStore();
const copyrights = computed(() => store.data?.copyrights);
</script>

<template>
  <section>
    <SectionTitle :placeholder="store.placeholderNotLoaded">
      {{ $t("G.LIT_Copyrights") }}
      <CopyIcon
        v-if="copyrights && !store.placeholderNotAuthorized"
        :value="copyrights"
        class="-mb-4"
        id="generalCopyCopyrightsButton"
        data-user-activity="Copied Copyrights"
      />
    </SectionTitle>
    <div v-if="store.placeholderNotAuthorized">
      <Placeholder
        :lines="2"
        full-width
      />
    </div>
    <div v-else-if="copyrights">
      {{ copyrights }}
    </div>
  </section>
</template>

<style scoped lang="postcss"></style>
